import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { CallNumber } from '@ionic-native/call-number';
// import { EmailComposer } from '@ionic-native/email-composer';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';

import { Storage } from '@ionic/storage';

// Mapa
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';

import { SocialSharing } from '@ionic-native/social-sharing';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

@Component({
	selector: 'page-empresa',
	templateUrl: 'empresa.html',
})
export class EmpresaPage {

	empresa = {nome: '', imagem: '', endereco: '', numero:'', bairro:'', cidade:'', uf:'', email: '', telefone:'', lat:0, lon: 0, cod_pais:''};
    imagem = '';

	constructor(public navCtrl: NavController, private _apiService: ApiProvider, private loadingCtrl: LoadingController, private launchNavigator: LaunchNavigator, private socialSharing: SocialSharing, private callNumber: CallNumber, /*private emailComposer: EmailComposer, */ private _auth: AuthProvider, private storage: Storage, private _msg: TranslateMsgProvider)
	{
		let loading = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+'...'
        });
        loading.present();

        this.storage.get('id_empresa_escolhida').then((val) => {
            this.storage.get('id_cliente').then((val2) => {
                /* Busca informações da empresa */
            	this._apiService.getInformacoesEmpresa({id_empresa_escolhida: val, id_cliente: val2}).subscribe(arg => {
                    // console.log(arg);
                    this.empresa.imagem = arg.config.imagem;
                    this.empresa.nome = arg.empresa.nome;
                    this.empresa.endereco = arg.empresa.endereco;
                    this.empresa.numero = arg.empresa.numero;
                    this.empresa.bairro = arg.empresa.bairro;
                    this.empresa.cidade = arg.empresa.cidade;
                    this.empresa.uf = arg.empresa.uf;
                    this.empresa.email = arg.empresa.email;
                    this.empresa.telefone = arg.empresa.telefone;
                    this.empresa.lat = arg.empresa.lat;
                    this.empresa.lon = arg.empresa.lon;
                    this.empresa.cod_pais = arg.empresa.cod_pais;
                    this.imagem = arg.imagemshare;
        			loading.dismiss();
                });
            });
        });
	}

    // Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter()
    {
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
        this._auth.checkempresa();
    }

    // Abrir mapa
    abrirmapa()
    {
        let options: LaunchNavigatorOptions = {
            destinationName: this.empresa.nome
        };

        this.launchNavigator.navigate([this.empresa.lat, this.empresa.lon], options)
            .then(
                success => console.log('Launched navigator'),
                error => console.log('Error launching navigator', error)
            );
    }

     /* Compartilha pontos */
    share()
    {
        this.storage.get('id_empresa_escolhida').then((emp) => {
            this._apiService.share({id_empresa: emp}).subscribe(arg=>{
                // console.log(arg);
                this.socialSharing.share(arg.message, arg.subject, arg.image, arg.url);
            });
        });
    }

    /* Ligar */
    ligar()
    {
        let tel = this.empresa.cod_pais+this.empresa.telefone;
        tel = tel.replace('(', '');
        tel = tel.replace(' ', '');
        tel = tel.replace(')', '');
        tel = tel.replace('-', '');
        this.callNumber.callNumber(tel, true)
        .then(() => console.log('Launched dialer!'))
        .catch(() => console.log('Error launching dialer'));
    }

    /* Enviar */
    enviar()
    {
        let email = {
          to: this.empresa.email,
          subject: this._msg.getMsg('CARTAO_CONTATO'),
          isHtml: true
        };

        // Send a text message using default options
        // this.emailComposer.open(email);
    }

}



// WEBPACK FOOTER //
// ./src/pages/empresa/empresa.ts